import type { Country, ListingAvailability } from '@bb/domain/dist/types';

// TODO: Adjust while testing QA
export const MAP_BOUNDS_PADDING = 20;

export const DEFAULT_INFO_WIDTH = 10;

export const DEFAULT_INFO_HEIGHT = 40;

export const MAX_TOUR_STOPS = 25;

export const DISPLAY_UNITS: Record<Country, google.maps.UnitSystem> = {
  CAN: google.maps.UnitSystem.METRIC,
  USA: google.maps.UnitSystem.IMPERIAL,
};

export const ERROR_MESSAGES: Record<google.maps.DirectionsStatus, string> = {
  NOT_FOUND: 'Error finding listing location.',
  ZERO_RESULTS: 'No direction can be found between start and end of the tour.',
  OVER_QUERY_LIMIT: 'Error finding directions, please refresh the page.',
  UNKNOWN_ERROR: 'Unknown Error, please refresh the page.',
  // Should not be reached
  OK: '',
  MAX_WAYPOINTS_EXCEEDED: 'Too many waypoints.',
  INVALID_REQUEST: 'Invalid API request.',
  REQUEST_DENIED: 'Request denied.',
};

export const FLOATING_PANEL_BAR_HEIGHT = 28; // prevent user from dragging the panel when content is not at the top

// these 2 are used as id to prevent body scroll on iOS:
export const TOURS_MAP_ID = 'geo-map';
export const TOURS_NAME_INPUT_ID = 'tours-input-name';

// showings status that should disable addToTour button regardless of noMoreShowings toggle
export const TOURS_DISABLED_SHOWING_STATUS: ListingAvailability[] = [
  'Sold',
  'Leased',
  'Expired',
  'Terminated',
  'Suspended',
  'Pending',
  'Withdrawn',
];
